import { ChoiceTypes } from '../enums';
import { FieldOption } from '../types';

export const choiceTypeList: Array<ChoiceTypes> = [
  ChoiceTypes.HARDWARE_TYPE,
  ChoiceTypes.MOBILE_TYPE,
  ChoiceTypes.MOBILE_ICON,
  ChoiceTypes.TIMEZONE,
  ChoiceTypes.OPERATOR,
  ChoiceTypes.PERMISSION_ACTION,
  ChoiceTypes.PROFILE_TYPE,
  ChoiceTypes.PERMISSION,
  ChoiceTypes.SENSOR_TYPE,
  ChoiceTypes.COMMAND,
  ChoiceTypes.ALARM,
  ChoiceTypes.MAINTENANCE_CLASS,
  ChoiceTypes.MAINTENANCE_ACTION,
];

export const choiceTypeOptions: Array<FieldOption> = choiceTypeList.map(
  choiceType => ({
    label: choiceType,
    value: choiceType
  })
);

export const unitTypeOptions: Array<FieldOption> = [
  {
    label: 'Distancia',
    value: 'distance-unit'
  },
  {
    label: 'Velocidad',
    value: 'speed-unit'
  }
]
